<!--
@file:面包屑组件,根据当前的路由名称显示对应的面包屑
-->
<template>
    <div id="breadcrumb">
        <p>{{ crumb }}</p>
    </div>
</template>

<script>
export default {
    name: 'breadcrumb',
    data () {
        return {
            menuList: {
                'all-cars': '车辆定位 / 所有车辆',
                'car-tracing': '车辆定位 / 车辆追踪',
                'mobile-trajectory': '车辆定位 / 车辆轨迹回放',
                'realtime-status': '电池状态 / 电池当前状态',
                'history-status': '电池状态 / 电池历史状态',
                'history-curve': '电池状态 / 历史状态曲线',
                'energy-analysis': '数据分析 / 车型能耗分析',
                'user-management': '账户管理 / 用户管理',
                'access-management': '账户管理 / 权限管理',
                'personal-center': '账户管理 / 用户中心',
                'cars-info': '基础管理 / 车辆信息管理'
            }
        };
    },
    computed: {
        crumb: function () {
            return this.menuList[this.$route.name];
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#breadcrumb {
    background-color: #fff;
    margin: 15px 0;
    border:1px solid #e0e3e7;
}
p{
    text-align: left;
    margin: 0;
    line-height: 31px;
    padding: 0 12px;
    color: #0066ff;
}
</style>



// WEBPACK FOOTER //
// breadcrumb.vue?6bfccf88